import { createApiCall } from 'lib/base';

const BACKFILL_WEALTH_MARKET_VALUE = 'WEALTH/BACKFILL_WEALTH_MARKET_VALUE';

const apiCall = createApiCall(
  BACKFILL_WEALTH_MARKET_VALUE,
  ({ id }: { id: string }) => ({
    endpoint: `/api/admin/wealth/programs/${id}/backfill-market-value`,
    method: 'POST',
    notify: true,
  })
);

export default apiCall;
